import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { SminexEventIcon } from '@shared/assets/icons';
import { colors } from '@shared/tokens/colors.stylex';
import { FC, ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.logo)}>
        <SminexEventIcon colorPrimary={colors.primaryText} colorSecondary={colors.accentBackground} />
      </div>
      {children}
    </div>
  );
};
